module.exports = __webpack_public_path__ + "img/menu31.774672c9.png";